import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig, MSALInstanceFactory } from './app/app.config';
import { App } from './app/app';
import { MSAL_INSTANCE } from '@azure/msal-angular';
import { SignalrService } from './app/core/services/signalr.service';

async function bootstrap() {
  try {
    const msalInstance = MSALInstanceFactory();
    await msalInstance.initialize();
    const providers = [...appConfig.providers];
    providers.push({
      provide: MSAL_INSTANCE,
      useFactory: () => {return msalInstance;}
    });

    const appRef = await bootstrapApplication(App, {
      ...appConfig,
      providers
    });

    const signalrService = appRef.injector.get(SignalrService);
    signalrService.startConnection();
  } catch (err) {
    console.error('Application error:', err);
  }
}

bootstrap();
